<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="dashboards"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a dashboard ID by choosing its name
     */
    export default {
        name: 'ies-dashboardKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                dashboards: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getDashboards();
        },
        methods: {
            getDashboards:function(){
                axios.get('/api/dashboards')
                .then(function(response){
                    var dashboards = [];
                    response.data.forEach(function(record){
                        dashboards.push({ text: record.system_name, value: record.dashboard_key });
                    });
                    this.dashboards = dashboards;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
